import ls from 'local-storage';
import React from 'react';
import { connect, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { fetchAuthData } from '../../actions/authUserActions';
import { refCompanyAction } from '../../actions/refCompanyAction';
import { withTranslation } from 'react-i18next';
import { CONTENT_DIRECTION } from '../../constants/contentDirection';
import {
  getLocalStorageItem,
  localStorageKey,
} from '../../services/localStorage';
import DOMPurify from 'dompurify';
import { BASE_URL } from '../../constants/variables';
import Loader from '../Loader/Loader';

class LoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      showPassword: false,
      first_login: true,
      loading: false,
    };
  }

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const { email, password } = this.state;
    const { fetchAuthData, history, refCompanyId } = this.props;
    // Prefer the Redux-provided id (always present here because <Login>
    // renders a <Loader /> until refCompData resolves). Fall back to
    // localStorage for backwards compatibility, then omit the field
    // entirely so the backend doesn't reject an empty string with
    // "A valid integer is required.".
    const refCompanyData = ls.get('refCompanyData');
    const company_id =
      refCompanyId ?? (refCompanyData && refCompanyData.id) ?? undefined;
    const payload = { email, password };
    if (company_id !== undefined && company_id !== '') {
      payload.company_id = company_id;
    }
    fetchAuthData(payload, history);
  };

  SSOButton = ({ t, i18n, auto_sso = false }) => {
    const refCompData = useSelector(
      (state) => state.refCompanyReducer.refCompData,
    );
    const ref_id = refCompData.ref_id;
    const oauth_login =
      BASE_URL + '/oauth_login?&ref_id=' + ref_id + '&system=Portal';
    if (auto_sso === 'true') {
      window.location.href = oauth_login;
      this.setState({ loading: true });
      return null;
    }
    if (!refCompData?.custom_sso?.has_portal_button) {
      return null;
    }
    return (
      <>
        <div class="hr-with-text">
          <hr />
          <span>{t('or')}</span>
          <hr />
        </div>
        <a
          style={{
            textAlign: 'center',
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: '#27A4A1',
            backgroundColor: '#fff',
            padding: '10px 20px',
            boxShadow: 'none',
            color: '#27A4A1',
          }}
          className="tr8s-button loginBtn loginSSOBtn"
          href={oauth_login}
        >
          <img
            src={refCompData?.custom_sso?.portal_logo}
            style={{ width: 21, marginLeft: 5, marginRight: 5 }}
            alt="G_LOGO"
          />
          {i18n.language === 'ar'
            ? refCompData?.custom_sso?.portal_button_text_ar
            : refCompData?.custom_sso?.portal_button_text}
        </a>
      </>
    );
  };

  render() {
    const { loginError, t, i18n } = this.props;
    const direction = localStorage.getItem('contentDirection');
    const token = localStorage.getItem('token');
    if (token) {
      this.props.history.push('/dashboard');
      return null;
    }
    if (this.state.loading) {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: 'calc(100vh - 140px)',
          }}
        >
          <Loader />
        </div>
      );
    }

    const refCompanyData = getLocalStorageItem(localStorageKey.refCompanyData);
    const query = new URLSearchParams(this.props.location.search);

    const error_message = query.get('error_message');
    const auto_sso = query.get('auto_sso');

    const loginLogo = this.props.logoURL ? (
      <img
        className="login-logo"
        src={this.props.logoURL}
        alt={this.props.logoAlt}
      />
    ) : refCompanyData && refCompanyData.logo ? (
      <img
        className="login-logo"
        src={DOMPurify.sanitize(refCompanyData.logo)}
        alt={refCompanyData.name}
      />
    ) : (
      <img className="login-logo" src="/assets/img/logo.png" alt="WhiteboxHR" />
    );

    if (this.state.first_login) {
      if (query.get('login_id')) {
        const login_id = query.get('login_id');
        const login_hash = query.get('login_hash');
        const company_id =
          this.props.refCompanyId ?? (refCompanyData ? refCompanyData.id : 1);
        this.props.fetchAuthData(
          { login_id, login_hash, sso_login: true, company_id },
          this.props.history,
        );
      }
      this.setState({ first_login: false });
    }

    return (
      <div className="auth-form-container text-center">
        {!this.props.userInfo ? loginLogo : ''}
        <p className="auth-form-title">
          {t('Welcome please login to your account')}
        </p>
        {loginError && <div className="errorBanner">{loginError}</div>}
        {error_message && <div className="errorBanner">{error_message}</div>}
        <form
          className={`${
            direction === CONTENT_DIRECTION.RTL ? 'text-left' : 'text-right'
          }`}
          onSubmit={this.handleSubmit}
        >
          <div className="form-group">
            <input
              className="auth-form-input"
              required
              placeholder={t('E-Mail')}
              name="email"
              type="email"
              value={this.state.email}
              onChange={this.handleInputChange}
            />
          </div>

          <div className="form-group position-relative">
            <input
              className="auth-form-input"
              required
              placeholder={t('Password')}
              type={this.state.showPassword ? 'text' : 'password'}
              name="password"
              value={this.state.password}
              onChange={this.handleInputChange}
            />
            <i
              onClick={() => {
                this.setState({ showPassword: !this.state.showPassword });
              }}
              className={`forgot-password-btn fas ${
                this.state.showPassword ? 'fa-eye-slash' : 'fa-eye'
              } ${direction === CONTENT_DIRECTION.RTL ? 'rtl' : ''}`}
            ></i>
            <Link
              className={`forgot-password-btn ${
                direction === CONTENT_DIRECTION.RTL ? 'rtl' : ''
              }`}
              to={'forgot-password'}
            >
              {t('Forgot password')}
            </Link>
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'end',
            }}
            className="form-group position-relative mb-0"
          >
            <div className="login-btns-container">
              <button
                className="tr8s-button loginBtn"
                onClick={this.handleSubmit}
                type="button"
              >
                {t('Login')}
              </button>
              <this.SSOButton t={t} i18n={i18n} auto_sso={auto_sso} />
            </div>
          </div>

          {this.props.allowSignup ? (
            <div className="login-signup-switch">
              <span>
                <Link className="footer-copyright" to={'sign-up'}>
                  {t('Dont have an account Sign up')}
                </Link>
              </span>
            </div>
          ) : null}
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loginError: state.authUser.error,
    loginLoader: state.authUser.isLoading,
  };
};

export default withTranslation()(
  connect(mapStateToProps, { fetchAuthData, refCompanyAction })(LoginForm),
);
